export { DatePickerInputOld } from './DatePickerInputOld';
export type { DatePickerInputOldProps } from './types';
